import { render, staticRenderFns } from "./template.html?vue&type=template&id=addc3384&scoped=true&external"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=addc3384&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addc3384",
  null
  
)

export default component.exports